import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Security: Disable right-click, inspect, devtools
if (process.env.NODE_ENV === "production" || true) {
  // Disable right-click
  document.addEventListener("contextmenu", (e) => e.preventDefault());
  
  // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  document.addEventListener("keydown", (e) => {
    if (e.key === "F12") { e.preventDefault(); return false; }
    if (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "i")) { e.preventDefault(); return false; }
    if (e.ctrlKey && e.shiftKey && (e.key === "J" || e.key === "j")) { e.preventDefault(); return false; }
    if (e.ctrlKey && (e.key === "U" || e.key === "u")) { e.preventDefault(); return false; }
    if (e.ctrlKey && e.shiftKey && (e.key === "C" || e.key === "c")) { e.preventDefault(); return false; }
  });

  // Detect devtools open
  const detectDevTools = () => {
    const threshold = 160;
    if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
      document.body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#0f1115;color:#ff4444;font-family:monospace;font-size:24px;text-align:center;padding:20px;">Access Denied<br><span style="font-size:14px;color:#666;">Developer tools detected. This session has been terminated.</span></div>';
    }
  };
  setInterval(detectDevTools, 1000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
